import * as React from 'react';
export const PHSvg = React.forwardRef(function PHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#555ABF',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M.7 11.52A2.01 2.01 0 0 1 0 9.99V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039L9 5.996.777 11.478a.5.5 0 0 1-.076.042Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M0 9.991V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039l.842.561A1 1 0 0 0 1 2v8a1 1 0 0 0 .611.922l-.834.556a.5.5 0 0 1-.076.042A2.01 2.01 0 0 1 0 9.99Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 4,
        cy: 6,
        r: 1,
        fill: '#F4B32E',
      }),
    ),
  );
});
PHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PH = {
  category: 'flag',
  colorable: false,
  name: 'PH',
  svg: PHSvg,
};
